export default __webpack_public_path__ + "static/media/login-bg-3.70a1cfb7.jpg";